<!-- A drop down menu item you click on that fires an event when clicked.  
        You can add a 'data' value to make generic calls
-->
<script lang="ts" setup>
    import DropDownItem from "./DropDownItem"
    import { computed } from 'vue';

    const props =  withDefaults(defineProps<
    {
        data?:any,
        baseClass?: string,
        disabledClass?: string
        enabled?: boolean
    }>(), {
        baseClass: "dropdown-item",
        disabledClass: "dropdown-item-text",
        enabled: true
    });

    const emit = defineEmits<{
        (e: "click", value:any): void
    }>();

    const defaultBaseClass = computed<string>(() => props.enabled ? props.baseClass : props.disabledClass);

    const onClick = () => {
        if (props.enabled)
            emit("click", props.data); 
    }
</script>

<template>
    <DropDownItem :usePointerStyle="true">
        <span :class="defaultBaseClass" @click="onClick">
            <slot class="color:red">
                Missing DropDownButtonItem slot content
            </slot>
        </span>
    </DropDownItem>
</template>